// AUTO-GENERATED by scripts/gen-keyword-tops.mjs — do not edit by hand.

export const PC_KEYWORDS_TH_TOP: string[] = [
  "ขอใบรับรองความประพฤติ",
  "ใบตรวจประวัติอาชญากรรม",
  "ตรวจประวัติอาชญากรรม",
  "ขอประวัติอาชญากรรม",
  "ใบแจ้งความประพฤติ",
  "ขอประวัติอาชญากรรม สำนักงานตำรวจแห่งชาติ",
  "ขอประวัติอาชญากรรม ออนไลน์",
  "ตรวจประวัติอาชญากรรม ออนไลน์",
  "ใบรับรองประวัติอาชญากรรม",
  "บริการขอใบรับรองความประพฤติ",
  "รับทำใบตรวจประวัติอาชญากรรม",
  "เอเจนซี่ขอใบรับรองความประพฤติ",
  "รับทำ police clearance",
  "ขอใบตรวจ",
  "ขอใบประวัติอาชญากรรม",
  "ขอหนังสือรับรองความประพฤติ",
  "ศูนย์ตรวจสอบประวัติอาชญากรรม",
  "กองทะเบียนประวัติอาชญากรรม",
  "ตรวจสอบประวัติอาชญากรรม สำนักงานตำรวจ",
  "ขอใบรับรองความประพฤติ ด่วน",
  "ขอใบประวัติอาชญากรรม ด่วน",
  "ขอใบรับรองความประพฤติ ราคา",
  "ตรวจประวัติอาชญากรรม กี่บาท",
  "ขอใบรับรองความประพฤติ ไปต่างประเทศ",
  "ใบประวัติอาชญากรรม ขอวีซ่าอเมริกา",
  "ใบประวัติอาชญากรรม ขอวีซ่าอังกฤษ",
  "ใบประวัติอาชญากรรม ขอวีซ่าออสเตรเลีย",
  "ใบประวัติอาชญากรรม ขอวีซ่าแคนาดา",
  "ขอใบรับรองความประพฤติ คนไทยในต่างประเทศ",
  "ขอประวัติอาชญากรรม คนไทยในต่างประเทศ",
  "มอบอำนาจขอใบรับรองความประพฤติ",
  "มอบอำนาจตรวจประวัติอาชญากรรม",
  "ขอใบรับรองความประพฤติ ชาวต่างชาติ",
  "ขอประวัติอาชญากรรม ชาวต่างชาติ",
  "ขอใบรับรองความประพฤติ ต่างชาติเคยอยู่ไทย",
  "ใบตรวจประวัติอาชญากรรม คู่สมรสต่างชาติ",
  "ตรวจประวัติอาชญากรรม คู่สมรส",
  "ขอใบรับรองความประพฤติ เรียนต่อต่างประเทศ",
  "ขอใบรับรองความประพฤติ แรงงานต่างประเทศ",
  "ขอใบรับรองความประพฤติ ปทุมวัน",
  "ขอประวัติอาชญากรรม สำนักงานตำรวจแห่งชาติ ปทุมวัน",
  "ตรวจในบางลำภู ขอใบรับรองความประพฤติ",
  "ขอใบรับรองความประพฤติ ใช้เอกสารอะไรบ้าง",
  "แบบฟอร์มขอใบรับรองความประพฤติ",
  "พิมพ์ลายนิ้วมือ ขอประวัติอาชญากรรม",
  "พิมพ์ลายนิ้วมือ สำนักงานตำรวจแห่งชาติ",
  "ใบพิมพ์ลายนิ้วมือ ต่างประเทศ",
  "ค่าธรรมเนียม ขอใบรับรองความประพฤติ",
  "ขอประวัติอาชญากรรม ราคา",
  "ขอใบรับรองความประพฤติ กี่วัน",
  "ตรวจประวัติอาชญากรรม ใช้เวลากี่วัน",
  "ขอประวัติอาชญากรรม ทางไปรษณีย์",
  "บริษัทรับขอประวัติอาชญากรรม",
  "บริการขอใบรับรองความประพฤติ ปทุมวัน",
  "บริการขอใบตรวจ ขอนแก่น",
  "บริการขอใบตรวจ อุดรธานี",
  "บริการขอใบตรวจ ภูเก็ต",
  "บริการขอใบตรวจ หนองคาย",
  "บริการขอใบตรวจ พัทยา",
  "บริการขอใบตรวจ เชียงใหม่",
  "รับรองกงสุลใบรับรองความประพฤติ",
  "Apostille ใบรับรองความประพฤติ",
  "ขอใบรับรองความประพฤติ พร้อมแปลภาษา",
  "ขอใบประวัติอาชญากรรม พร้อมแปลและรับรอง",
  "รับแปลภาษาและขอใบรับรองความประพฤติ",
  "ขอประวัติอาชญากรรม พร้อมรับรอง MFA",
  "ขอใบรับรองความประพฤติ ด่วน 1 วัน",
  "ขอใบรับรองความประพฤติ ด่วน 3 วัน",
  "ขอใบรับรองความประพฤติ คนต่างด้าว",
  "ขอประวัติอาชญากรรม แรงงานต่างด้าว",
  "ใบประวัติอาชญากรรม วีซ่าทำงาน",
  "ขอประวัติอาชญากรรม วีซ่าธุรกิจ",
  "ขอประวัติอาชญากรรม เปลี่ยนชื่อ",
  "ขอใบตรวจ พาสปอร์ตหมดอายุ",
  "ขอใบรับรองความประพฤติ ไม่มีพาสปอร์ต",
  "ขอใบรับรองความประพฤติ บัตรประชาชนหาย",
  "ขอใบประวัติอาชญากรรม ทหารเกณฑ์",
  "ขอประวัติอาชญากรรม รับราชการทหาร",
  "ขอใบตรวจ เคยต้องโทษ",
  "สำเนาคำพิพากษา ขอใบตรวจ",
  "สำเนาใบบริสุทธิ์ ขอประวัติอาชญากรรม",
  "Release Certificate ขอประวัติอาชญากรรม",
  "ขอใบรับรองความประพฤติ เยาวชนอายุต่ำกว่า 18",
  "ใบยินยอมผู้ปกครอง ขอประวัติอาชญากรรม",
  "ขอใบตรวจ คู่สมรสชาวต่างชาติ",
  "ขอใบประวัติอาชญากรรม นักเรียนแลกเปลี่ยน",
  "ตรวจประวัติอาชญากรรม ขอใบขับขี่สากล",
  "ตรวจประวัติอาชญากรรม ขอใบอนุญาตพกพาอาวุธปืน",
  "ตรวจประวัติอาชญากรรม รปภ",
  "ตรวจประวัติอาชญากรรม พนักงานโรงแรม",
  "ตรวจประวัติอาชญากรรม พนักงานขับรถ",
  "ตรวจประวัติอาชญากรรม ไรเดอร์",
  "ขอประวัติอาชญากรรม สมัคร Grab",
  "ขอประวัติอาชญากรรม สมัคร Lineman",
  "ขอใบรับรองความประพฤติ อาชีพแพทย์",
  "ขอใบรับรองความประพฤติ อาชีพพยาบาล",
  "เอกสารพิมพ์ลายนิ้วมือ FBI",
  "FBI Fingerprinting กรุงเทพ",
  "RCMP Fingerprinting Thailand",
  "AFP Police Check จากไทย",
  "ขอใบประวัติอาชญากรรม จีน จากไทย",
  "ขอใบประวัติอาชญากรรม ญี่ปุ่น จากไทย",
  "บริการพิมพ์ลายนิ้วมือ ภูเก็ต",
  "บริการพิมพ์ลายนิ้วมือ ขอนแก่น",
  "บริการพิมพ์ลายนิ้วมือ อุดรธานี",
  "บริการพิมพ์ลายนิ้วมือ หนองคาย",
  "รับรองลายพิมพ์ลายนิ้วมือ Notary Public",
  "Legalise Fingerprint Form Thailand",
  "ขอใบตำรวจ แบบฟอร์มออนไลน์",
  "ตรวจสอบประวัติอาชญากรรม ด้วยชื่อนามสกุล",
  "ตรวจประวัติพนักงาน HR",
  "Corporate Background Check Thailand",
  "ตรวจประวัติอาชญากรรมก่อนรับเข้าทำงาน นิติบุคคล",
  "Thai Police Clearance Apostille",
  "ขอใบตำรวจ วีซ่าคู่หมั้นอเมริกา K1",
  "ขอใบประวัติอาชญากรรม วีซ่าคู่สมรสอังกฤษ",
  "ขอใบรับรองความประพฤติ วีซ่าทำงานสิงคโปร์",
  "ใบประวัติอาชญากรรม ทำงานดูไบ",
  "ใบประวัติอาชญากรรม ทำงานกาตาร์",
  "ขอใบรับรองความประพฤติ ขอวีซ่าเชงเก้น"
];
export const PC_KEYWORDS_TH_TOP_TOTAL = 208;

export const PC_KEYWORDS_EN_TOP: string[] = [
  "police clearance thailand",
  "police clearance certificate thailand",
  "thai police clearance",
  "thai police check",
  "criminal record check thailand",
  "police certificate thailand",
  "background check thailand",
  "thailand criminal background check",
  "urgent police clearance thailand",
  "thai police clearance cost",
  "police clearance thailand fee",
  "thai police clearance processing time",
  "police clearance thailand by mail",
  "police clearance agency bangkok",
  "police clearance service thailand",
  "criminal record certificate thailand",
  "thai certificate of good conduct",
  "certificate of good conduct thailand",
  "police clearance with apostille thailand",
  "police clearance thailand from abroad",
  "police clearance thailand overseas",
  "applying for thai police clearance from overseas",
  "police clearance thailand for foreigners",
  "criminal record check thailand for foreigners",
  "thai police clearance for non thai citizens",
  "police clearance thailand former expat",
  "police check thailand for expats",
  "police clearance thailand employment",
  "police clearance for australian visa",
  "police clearance thailand for us visa",
  "police clearance thailand for uk visa",
  "thai police clearance k1 visa",
  "thai police clearance uk spouse visa",
  "thai police clearance for singapore mom",
  "thai police clearance for uae",
  "thai police clearance for qatar",
  "thai police clearance schengen visa",
  "thai police clearance service for thais in australia",
  "thai police clearance service for thais in uk",
  "thai police clearance service for thais in usa",
  "trusted thai police clearance agency",
  "thai police check power of attorney service",
  "hire agent for thai police clearance",
  "thai police clearance investor visa",
  "thai police check for visa extension",
  "thai police clearance australian citizenship",
  "thai police clearance us citizenship",
  "fingerprinting for thai police check at local station",
  "photos required for thai police clearance",
  "certified documents for thai police check",
  "check thai police clearance status online",
  "fast track thai police clearance 2026",
  "thai police clearance agent isan",
  "udon thani agency thai police clearance",
  "khon kaen agency thai police clearance",
  "nong khai agency thai police clearance",
  "phuket agency thai police clearance",
  "thai police clearance near bts",
  "thai police clearance center working hours",
  "thai police clearance public holidays",
  "thai police clearance without old passport",
  "thai police clearance upcountry house registration",
  "thai police clearance changed surname",
  "thai police clearance for laotian",
  "thai police clearance for myanmar citizens",
  "thai police clearance for cambodian",
  "thai police clearance for mou workers",
  "employment letter for thai police clearance",
  "sponsor letter for thai police check",
  "police clearance for international marriage thailand",
  "thai police clearance ministry of labour",
  "thai police clearance international shipping",
  "affordable thai police clearance service",
  "reliable thai police clearance company",
  "mobile fingerprinting service thailand",
  "mobile fingerprinting udon thani",
  "mobile fingerprinting khon kaen",
  "mobile fingerprinting phuket",
  "thai police clearance document checklist",
  "thai police check fee 2026",
  "one stop service thai police clearance",
  "thai police clearance exchange student",
  "police check for gun license thailand",
  "police check for security guard thailand",
  "background check for delivery drivers thailand",
  "police check for nurses thailand",
  "police check for doctors thailand",
  "fbi fingerprinting service bangkok",
  "rcmp fingerprinting thailand",
  "australian federal police check from thailand",
  "fingerprinting service phuket",
  "fingerprinting service khon kaen",
  "fingerprinting service udon thani",
  "fingerprinting service nong khai",
  "fingerprint card notary thailand",
  "background check by name thailand",
  "national police check thailand",
  "criminal background screening thailand",
  "corporate background check thailand",
  "employee background verification thailand",
  "thai police clearance apostille service",
  "fingerprint card fbi fd-258 thailand",
  "download fingerprint form fd-258",
  "police clearance thailand form download",
  "request letter for thai police clearance",
  "company request letter for police check",
  "get thai police clearance from khon kaen",
  "get thai police clearance from udon thani",
  "get thai police clearance from nong khai",
  "get thai police clearance from phuket",
  "translate and notarize thai police clearance",
  "naati translation thai police clearance",
  "certified translation police clearance thailand",
  "thai police clearance fast processing",
  "thai police clearance 7 days",
  "police clearance for migrant workers thailand",
  "thai police clearance business visa",
  "thai police clearance name mismatch",
  "thai police clearance old passport",
  "lost passport thai police clearance"
];
export const PC_KEYWORDS_EN_TOP_TOTAL = 151;
